// extracted by mini-css-extract-plugin
module.exports = {"startActive":"index_startActive__3F_pu","start":"index_start__H9gBA"};